import { Formik, FormikActions } from 'formik';
import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import * as Icons from 'react-icons/md';
import { connect } from 'react-redux';
import { Modal, Table, UncontrolledTooltip } from 'reactstrap';
import { SecureImage } from '../../../../components/core/secureImage';
import { SelectNoneAsync } from '../../../../components/input/select/main';
import Loading from '../../../../components/loading/loading';
import Paginate from '../../../../components/table/paginate';
import SortedColumn from '../../../../components/table/sorted-column';
import Announce from '../../../../components/templates/announce';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import {
    IAddModalProps,
    IStudentItem,
    StudentAddModalFilterValues,
    IFilterStudent
} from '../../../../models/components/add-activity-project-content';
import { UserType } from '../../../../models/enums/userType';
import * as Actions from '../../../../store/actions/project';

const T = Translator.create();
const _logger = Log.create('Project Activity');

export const filterInitialValues: any = {
    searchKey: '',
    courseId: 'null',
    classId: 'null',
    userType: 0,
    groupId: null,
    take: 10,
    skip: 0,
    total: 0
};

function getInitialState(): any {
    const initialValues: any = {
        selectMenuIsOpen: true,
        currentTab: 'all',
        selectedList: [],
        selected_ids: [],
        filters: Object.assign({}, StudentAddModalFilterValues),
        filterIsOpen: false,
        userList: []
    };
    return Object.assign({}, initialValues);
}

class UserAddModal extends Component<any, any> {
    state: any = getInitialState();

    componentDidMount() {
        this.getUsers();
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.props.selectedUserList.length && prevProps.selectedUserList !== this.props.selectedUserList) {
            const selectedIdsFromProps = this.props.selectedUserList.map((user: any) => user.hashedUserId);
            this.setState({
                selectedList: this.props.selectedUserList,
                selected_ids: selectedIdsFromProps,
                currentTab: 'selecteds'
            });
        }

        if (this.props.userList.length && prevProps.userList !== this.props.userList) {
            this.setState({
                userList: this.props.userList
            });
        }
    }

    getUsers() {
        const disallowedGroupIds: any[] = [];
        if (!this.state.filters.groupId && this.props.disallowedGroupIds && this.props.disallowedGroupIds.length) {
            this.props.disallowedGroupIds.map((group: any) => disallowedGroupIds.push(group.hashedGroupId));
        }
        this.props.dispatch(
            Actions.getAddModalUserList(this.props.coursePageClassId, this.props.coursePageActivityId, this.state.filters, false, 'getCourseUserList', 'get', disallowedGroupIds, this.props.selectedGroupId ? this.props.selectedGroupId : '')
        );
    }

    onCloseModal = () => {
        this.props.dispatch(Actions.setProjectFetchUsersOfGroup([], StudentAddModalFilterValues, undefined, 'set'));
        this.props.setCloseModal();
    };

    selectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        const currentUserListIds = this.state.userList.map((user: any) => user.hashedUserId);
        if (event.target.checked) {
            const ids = currentUserListIds.filter((id: string) => !this.state.selected_ids.includes(id));
            this.setState({
                selected_ids: [...this.state.selected_ids, ...ids],
                selectedList: [...this.state.selectedList, ...this.state.userList]
            });
        } else {
            const ids = this.state.selected_ids.filter((id: string) => !currentUserListIds.includes(id));
            const userList = this.state.selectedList.filter((user: any) => !currentUserListIds.includes(user.hashedUserId));

            this.setState({
                selected_ids: ids,
                selectedList: userList
            });
        }
    };

    areAllUsersSelected = (): boolean => this.state.userList.every((user: any) => this.state.selected_ids.includes(user.hashedUserId));

    sort = (sortkey: string, orderBy: string) => {
        const sortString = sortkey + '_' + orderBy;
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                orderBy: sortString
            }
        });
        this.getUsers();
    };

    onFilterUserList(model: IFilterStudent, FormActions: FormikActions<IFilterStudent>) {
        this.state.filters = model;
        this.state.filters.page = 1;
        this.getUsers();
        FormActions.setSubmitting(false);
    }

    onFormReset = () => {
        this.state.filters = Object.assign({}, StudentAddModalFilterValues);
        this.setState(this.state);
        this.getUsers();
    };

    onSaveUsers = () => {
        this.props.dispatch(Actions.getAddModalSaveUsers(this.props.groupId, this.state.selected_ids, '', 'get'));
        this.props.onUpdateGroup(this.props.groupId, this.state.selected_ids.length);
        this.props.setCloseModal();
    };

    onSelectUser = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target) {
            const selectedIds = Object.assign([], this.state.selected_ids);
            const selectedObjects = Object.assign([], this.state.selectedList);
            const id: string = event.currentTarget.dataset.id || '';
            const userObject = this.props.userList.find((item: any) => item.hashedUserId === id);
            if (event.target.checked) {
                selectedIds.push(id);
                selectedObjects.push(userObject);
            } else {
                const index = selectedIds.indexOf(id);
                if (index !== -1) {
                    const currentObject = selectedObjects.find((item: any) => item.hashedUserId === id);
                    const objectIndex = selectedObjects.indexOf(currentObject);
                    selectedIds.splice(index, 1);
                    selectedObjects.splice(objectIndex, 1);
                }
            }
            this.setState({
                selected_ids: selectedIds,
                selectedList: selectedObjects
            });
        }
    };

    onRemoveFromSelecteds = (event: React.MouseEvent<HTMLButtonElement>) => {
        const id: string = event.currentTarget.dataset.id || '';

        const selectedIds = Object.assign([], this.state.selected_ids);
        const selectedObjects = Object.assign([], this.state.selectedList);

        const index = selectedIds.indexOf(id);
        const objectIndex = selectedObjects.findIndex((item: any) => item.hashedUserId === id);

        selectedIds.splice(index, 1);
        selectedObjects.splice(objectIndex, 1);

        this.setState({
            selected_ids: selectedIds,
            selectedList: selectedObjects
        });
    };

    onPageChange = (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        this.getUsers();
    };

    changeTab = (tabName: string) => {
        this.setState({
            currentTab: tabName
        });
    };

    render() {
        const userList = this.props.userList && this.props.userList.length ? this.props.userList : [];
        return (
            <Modal
                className="pt-0"
                style={{ maxWidth: '60%', padding: '0 15px' }}
                isOpen={this.props.isModalOpen}
                toggle={this.onCloseModal}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title d-inline-flex align-items-center" id="exampleModalLabel">
                            {T.t('r_user_add_modal_title')}
                        </h6>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onCloseModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="container-fluid p-0">
                            <div className="row">
                                <div className="col-12 modal-from-right">
                                    <ul className="nav nav-tabs border-0" style={{paddingInlineStart: '0px'}} id="tabs" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className={this.state.currentTab === 'all' ? 'nav-link active' : 'nav-link '}
                                                // tslint:disable-next-line
                                                onClick={() => this.changeTab('all')}
                                                id="all-users-tab"
                                            >
                                                {T.t('r_user_add_modal_all_users')}
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={this.state.currentTab === 'selecteds' ? 'nav-link active' : 'nav-link '}
                                                // tslint:disable-next-line
                                                onClick={() => this.changeTab('selecteds')}
                                                id="selecteds-tab"
                                            >
                                                {T.t('r_user_add_modal_selected_users')}
                                                {this.state.selected_ids.length ? <b>&nbsp;({this.state.selected_ids.length})</b> : null}
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="tabContent" style={{ padding: '5px' }}>
                                        <div
                                            className={'tab-pane fade' + (this.state.currentTab === 'all' ? ' show active' : '')}
                                            style={{ width: '100%' }}
                                            role="tabpanel"
                                            aria-labelledby="all-users-tab"
                                        >
                                            <div className="row">
                                                <div className="quick-actions" style={{ width: '100%' }}>
                                                    <button
                                                        className="category-tag-square tag-glass float-right mr-3"
                                                        style={{ margin: '5px' }}
                                                        // tslint:disable-next-line:jsx-no-lambda
                                                        onClick={() => {
                                                            this.state.filterIsOpen = !this.state.filterIsOpen;
                                                            this.setState(this.state);
                                                        }}
                                                    >
                                                        <i className="material-icons mr-2">filter_list</i>
                                                        <span>{T.t('r_fileUpload_filter')}</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div
                                                    className={`white-container mt-4 collapse ` + (this.state.filterIsOpen ? `show` : ``)}
                                                    style={{ width: '100%' }}
                                                    id="advance-search"
                                                >
                                                    <div className="advance-search d-block mt-3 ml-3 mr-3">
                                                        <Formik
                                                            initialValues={filterInitialValues}
                                                            enableReinitialize={true}
                                                            // tslint:disable-next-line:jsx-no-lambda
                                                            onSubmit={(values, actions) => {
                                                                this.onFilterUserList(values, actions);
                                                            }}
                                                            onReset={this.onFormReset}
                                                        >
                                                            {(props: any) => {
                                                                return (
                                                                    <form onSubmit={props.handleSubmit} key={'project_add_user_modal'}>
                                                                        <div
                                                                            className="row"
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'baseline'
                                                                            }}
                                                                        >
                                                                            <div className="col-md-6">
                                                                                <div className="form-input form-group date-picker">
                                                                                    <input
                                                                                        id="searchKey"
                                                                                        name="searchKey"
                                                                                        value={props.values.searchKey}
                                                                                        onChange={props.handleChange}
                                                                                        type="text"
                                                                                        required={true}
                                                                                    />
                                                                                    <span className="highlight" />
                                                                                    <span className="bar" />
                                                                                    <label htmlFor="searchKey">
                                                                                        {T.t('r_filter_name_surname_email')}
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="add-custom-tag mb-3">
                                                                                    <div className="react-select-container">
                                                                                        <SelectNoneAsync
                                                                                            name={'selectType'}
                                                                                            touched={props.touched.userType}
                                                                                            // errors={props.errors.userType}
                                                                                            setOptions={[
                                                                                                {
                                                                                                    value: UserType.Student,
                                                                                                    label: T.t('r_gen_student')
                                                                                                },
                                                                                                {
                                                                                                    value: UserType.Teacher,
                                                                                                    label: T.t('r_gen_teacher')
                                                                                                }
                                                                                            ]}
                                                                                            // tslint:disable-next-line:jsx-no-lambda
                                                                                            onChange={(e: any) =>
                                                                                                props.setFieldValue(
                                                                                                    'userType',
                                                                                                    e ? e.value : 0
                                                                                                )
                                                                                            }
                                                                                            isTouched={props.setFieldTouched}
                                                                                            setSelectValue={
                                                                                                props.values.userType
                                                                                                    ? [props.values.userType]
                                                                                                    : []
                                                                                            }
                                                                                            placeHolder={T.t('r_select_user_type')}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="mt-3"
                                                                            style={{ textAlign: 'center', alignItems: 'center' }}
                                                                        >
                                                                            <button
                                                                                type="button"
                                                                                className="ml-3 category-tag-square tag-gray"
                                                                                onClick={props.handleReset}
                                                                            >
                                                                                <i className="material-icons">close</i>&nbsp;
                                                                                {T.t('r_gen_clear')}
                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="ml-3 category-tag-square tag-green"
                                                                                onClick={props.handleSubmit}
                                                                                disabled={props.isSubmitting}
                                                                            >
                                                                                <i className="material-icons mr-2">search</i>
                                                                                {T.t('r_gen_search')}
                                                                            </button>
                                                                        </div>
                                                                    </form>
                                                                );
                                                            }}
                                                        </Formik>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="container">
                                                    <div className="page-table p-0 m-t-0">
                                                        <Loading spinnerId={'getCourseUserList'} width={50} />
                                                        <Table
                                                            className="table-user-list table-ellipsis"
                                                            striped={true}
                                                            hover={true}
                                                            borderless={true}
                                                        >
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#e1e3e4' }}>
                                                                    <th data-cell="select">
                                                                        <div className="tick-radio position-relative">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-radio"
                                                                                onChange={this.selectAll}
                                                                                checked={this.areAllUsersSelected()}
                                                                                id="select_all"
                                                                            />
                                                                            <UncontrolledTooltip placement="top" target={'select_all'}>
                                                                                {T.t('r_select_all')}
                                                                            </UncontrolledTooltip>
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="text-center">
                                                                        {T.t('r_profile_photo')}
                                                                    </th>
                                                                    <SortedColumn
                                                                        datacell="firstName"
                                                                        className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                                        title={T.t('r_firstname')}
                                                                        sortkey="firstName"
                                                                        sortedcolumn={
                                                                            this.state.filters.orderBy ? this.state.filters.orderBy : ''
                                                                        }
                                                                        sort={this.sort}
                                                                    />
                                                                    <SortedColumn
                                                                        datacell="lastName"
                                                                        className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                                        title={T.t('r_lastname')}
                                                                        sortkey="lastName"
                                                                        sortedcolumn={
                                                                            this.state.filters.orderBy ? this.state.filters.orderBy : ''
                                                                        }
                                                                        sort={this.sort}
                                                                    />
                                                                    <SortedColumn
                                                                        datacell="userName"
                                                                        className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                                        title={T.t('r_username')}
                                                                        sortkey="userName"
                                                                        sortedcolumn={
                                                                            this.state.filters.orderBy ? this.state.filters.orderBy : ''
                                                                        }
                                                                        sort={this.sort}
                                                                    />
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {userList && userList.length ? (
                                                                    userList.map((item: IStudentItem) => {
                                                                        return (
                                                                            <tr
                                                                                key={'user-' + item.hashedUserId}
                                                                                data-title={item.userName}
                                                                            >
                                                                                <td data-cell="select">
                                                                                    <div className="tick-radio position-relative">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-radio"
                                                                                            checked={this.state.selected_ids.includes(
                                                                                                item.hashedUserId
                                                                                            )}
                                                                                            data-id={item.hashedUserId}
                                                                                            onChange={this.onSelectUser}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td
                                                                                    data-label={T.t('r_profile_photo')}
                                                                                    className="text-center"
                                                                                >
                                                                                    <SecureImage
                                                                                        imageUrl={item.userAvatar ? item.userAvatar : ''}
                                                                                        style={{ maxWidth: '40px' }}
                                                                                        class={''}
                                                                                    />
                                                                                </td>
                                                                                <td data-label={T.t('r_firstname')} className="text-center">
                                                                                    {item.firstName}
                                                                                </td>
                                                                                <td data-label={T.t('r_lastname')} className="text-center">
                                                                                    {item.lastName}
                                                                                </td>
                                                                                <td data-label={T.t('r_username')} className="text-center">
                                                                                    {item.userName}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <Announce title={T.t('r_no_record_found')} />
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                        <div className="row-options justify-content-end">
                                                            <div
                                                                className="page-sorting d-flex align-items-center justify-content-center"
                                                                style={{ marginTop: '5px' }}
                                                            />
                                                            {this.props.userList && this.props.userList.length > 0 && (
                                                                <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className={'tab-pane fade' + (this.state.currentTab === 'selecteds' ? ' show active' : '')}
                                            style={{ width: '100%' }}
                                            role="tabpanel"
                                            aria-labelledby="selecteds-tab"
                                        >
                                            <div className="row">
                                                <div
                                                    className="container"
                                                    style={{ minHeight: '60vh', maxHeight: '64vh', overflow: 'hidden auto' }}
                                                >
                                                    <div className="page-table p-0 m-t-0" style={{ minHeight: '56vh' }}>
                                                        <Loading spinnerId={'getCourseUserList'} width={50} />
                                                        <Table
                                                            className="table-user-list table-ellipsis"
                                                            striped={true}
                                                            hover={true}
                                                            borderless={true}
                                                        >
                                                            <thead>
                                                                <tr style={{ backgroundColor: '#e1e3e4' }}>
                                                                    {this.state.selected_ids.length ? (
                                                                        <th data-cell="select" className="table-buttons">
                                                                            <button
                                                                                className="btn btn-sm"
                                                                                style={{ backgroundColor: '#f8f9fa' }}
                                                                                // tslint:disable-next-line:jsx-no-lambda
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        selectedList: [],
                                                                                        selected_ids: []
                                                                                    });
                                                                                }}
                                                                                id={'tooltip-remove-all'}
                                                                            >
                                                                                <Icons.MdDeleteForever color="#ff6868" />
                                                                            </button>
                                                                            <UncontrolledTooltip
                                                                                placement="top"
                                                                                target={'tooltip-remove-all'}
                                                                            >
                                                                                {T.t('r_select_remove_all_selecteds')}
                                                                            </UncontrolledTooltip>
                                                                        </th>
                                                                    ) : null}
                                                                    <th scope="col" className="text-center">
                                                                        {T.t('r_profile_photo')}
                                                                    </th>
                                                                    <SortedColumn
                                                                        datacell="firstName"
                                                                        className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                                        title={T.t('r_firstname')}
                                                                        sortkey="firstName"
                                                                        sortedcolumn={
                                                                            this.state.filters.orderBy ? this.state.filters.orderBy : ''
                                                                        }
                                                                        sort={this.sort}
                                                                    />
                                                                    <SortedColumn
                                                                        datacell="lastName"
                                                                        className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                                        title={T.t('r_lastname')}
                                                                        sortkey="lastName"
                                                                        sortedcolumn={
                                                                            this.state.filters.orderBy ? this.state.filters.orderBy : ''
                                                                        }
                                                                        sort={this.sort}
                                                                    />
                                                                    <SortedColumn
                                                                        datacell="userName"
                                                                        className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                                        title={T.t('r_username')}
                                                                        sortkey="userName"
                                                                        sortedcolumn={
                                                                            this.state.filters.orderBy ? this.state.filters.orderBy : ''
                                                                        }
                                                                        sort={this.sort}
                                                                    />
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.selectedList && this.state.selectedList.length ? (
                                                                    this.state.selectedList.map((item: IStudentItem) => {
                                                                        return (
                                                                            <tr
                                                                                key={'user-' + item.hashedUserId}
                                                                                data-title={item.userName}
                                                                            >
                                                                                <td data-cell="select" className="table-buttons">
                                                                                    <button
                                                                                        className="btn btn-sm"
                                                                                        style={{ backgroundColor: '#f8f9fa' }}
                                                                                        onClick={this.onRemoveFromSelecteds}
                                                                                        data-id={item.hashedUserId}
                                                                                        id={'tooltip-' + item.hashedUserId}
                                                                                    >
                                                                                        <Icons.MdDeleteForever color="#ff6868" />
                                                                                    </button>
                                                                                    <UncontrolledTooltip
                                                                                        placement="top"
                                                                                        target={'tooltip-' + item.hashedUserId}
                                                                                    >
                                                                                        {T.t('r_select_remove_selected')}
                                                                                    </UncontrolledTooltip>
                                                                                </td>
                                                                                <td
                                                                                    data-label={T.t('r_profile_photo')}
                                                                                    className="text-center"
                                                                                >
                                                                                    <SecureImage
                                                                                        imageUrl={item.userAvatar ? item.userAvatar : ''}
                                                                                        style={{ maxWidth: '40px' }}
                                                                                        class={''}
                                                                                    />
                                                                                </td>
                                                                                <td data-label={T.t('r_firstname')} className="text-center">
                                                                                    {item.firstName}
                                                                                </td>
                                                                                <td data-label={T.t('r_lastname')} className="text-center">
                                                                                    {item.lastName}
                                                                                </td>
                                                                                <td data-label={T.t('r_username')} className="text-center">
                                                                                    {item.userName}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <Announce title={T.t('r_no_record_found')} />
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                        <div className="row-options justify-content-end">
                                                            <div
                                                                className="page-sorting d-flex align-items-center justify-content-center"
                                                                style={{ marginTop: '5px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="quick-actions mt-2" style={{ width: '100%' }}>
                                                    <button
                                                        className="category-tag-square tag-green float-right mr-3"
                                                        style={{ margin: '5px' }}
                                                        // tslint:disable-next-line:jsx-no-lambda
                                                        onClick={() => this.onSaveUsers()}
                                                    >
                                                        <i className="material-icons mr-2">save</i>
                                                        <span>{T.t('r_gen_save')}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddModalProps): IAddModalProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAddModalProps = Object.assign({}, ownProps, {
        userList: state.users.addModalAllData ? state.users.addModalAllData.results : [],
        selectedUserList: state.users.addModalSelectedData ? state.users.addModalSelectedData.results : [],
        filters: state.users.addModalAllData ? state.users.addModalAllData.filters : {},
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        userPreferences: state.profile.userPreferences.preferences
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return next.users.addModalAllData === prev.users.addModalAllData || next.users.addModalSelectedData === prev.users.addModalAllData;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const container = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(UserAddModal);

export default container;
